import * as mt from './mutation-types';
import { LocationState, LocationDelegate, toStateKey } from './types'
import { CountryDTO, City, CityDTO } from '@/api/location/types';

export default {
  [mt.SETUP](state: LocationState, { delegate }: { delegate: LocationDelegate }) {
    state.delegate = delegate;
  },
  [mt.CLEAR](state: LocationState) {
    state.countries = [];
    state.deferred = {};
    state.states = new Map();
    state.cities = new Map();
    state.statesOptions = [];
    state.citiesOptions = [];
    state.countryContext = '';
    state.stateContext = '';
    state.cityContext = '';
    state.status = 'initial';
  },
  [mt.CLEAR_STATE](state: LocationState) {
    state.stateContext = '';
  },
  [mt.CLEAR_CITY](state: LocationState) {
    state.cityContext = '';
  },
  [mt.FETCH_COUNTRIES](state: LocationState, { countries }: { countries: string[] }) {
    state.countries = countries;
    state.status = 'ready:countries';
  },
  [mt.FETCHING_COUNTRIES](state: LocationState) {
    state.status = 'fetching:countries';
  },
  [mt.SELECT_COUNTRY](state: LocationState, { country }: { country: string }) {
    state.countryContext = country;
  },
  [mt.DEFER_SELECT_COUNTRY](state: LocationState, { countryContext } : { countryContext: string}) {
    state.deferred = { ...state.deferred, country: countryContext }
  },
  [mt.COMMIT_COUNTRY](state: LocationState) {
    if (!!state.deferred.country) {
      delete state.deferred.country;
    }
  },
  [mt.FETCH_STATES](state: LocationState, countryDTO: CountryDTO) {
    state.statesOptions = countryDTO.states;
    state.states.set(countryDTO.country, countryDTO);
    state.states = new Map(state.states);
    state.status = 'ready:states';
  },
  [mt.FETCHING_STATES](state: LocationState) {
    state.status = 'fetching:states';
  },
  [mt.SELECT_STATE](st: LocationState, { state }: { state: string }) {
    st.stateContext = state;
  },
  [mt.DEFER_SELECT_STATE](state: LocationState, { stateContext } : { stateContext: string}) {
    state.deferred = { ...state.deferred, state: stateContext }
  },
  [mt.COMMIT_STATE](state: LocationState) {
    if (!!state.deferred.state) {
      delete state.deferred.state;
    }
  },
  [mt.FETCHING_CITIES](state: LocationState) {
    state.status = 'fetching:cities';
  },
  [mt.FETCH_CITIES](st: LocationState, { country, state, cities }: { country: string, state: string, cities: City[] }) {
    st.citiesOptions = cities;
    const key = toStateKey(country, state);
    st.cities.set(key, cities);
    st.cities = new Map(st.cities);
    st.status = 'ready:cities';
  },
  [mt.SELECT_CITY](state: LocationState, { city }: { city: City }) {
    state.cityContext = city;
  },
  [mt.DEFER_SELECT_CITY](state: LocationState, { cityContext } : { cityContext: City}) {
    state.deferred = { ...state.deferred, city: cityContext }
  },
  [mt.COMMIT_CITY](state: LocationState) {
    if (!!state.deferred.city) {
      delete state.deferred.city;
    }
  },
  [mt.FETCHING_CITY_CENTROID](state: LocationState) {
    state.stateForCentroid = 'fetching';
    state.cityFromCentroid = null;
  },
  [mt.FETCH_CITY_CENTROID](state: LocationState,  cityDTO: CityDTO ) {
    state.stateForCentroid = 'ready';
    state.cityFromCentroid = cityDTO;
  }
};
